import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  LeaveContactsModal,
  TLeaveContactsModalOnSubmitParams,
  attemptToGetMessageFromUnknownError,
} from '@cian/frontend-e2e-deal-component';

import { closeLeaveContactsModal, sendConsultationRequest } from '../../actions/leaveContacts';
import { TThunkDispatch } from '../../types/redux';
import { NBSP } from '../../constants/symbols';
import { trackConsultationRequestFormSubmit } from './tracking';
import { selectIsLeaveContactsModalOpened } from '../../selectors/leaveContacts';

const MODAL_TEXTS = {
  title: 'Оставьте свои контакты',
  subtitle: `Специалист свяжется с вами и расскажет про процесс и${NBSP}дальнейшие шаги.`,
  success: 'Специалист перезвонит вам в ближайшее время',
} as const;

/**
 * Модалка с формой заявки "Хочу консультацию"
 */
export const ConsultationRequestModalContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isOpened = useSelector(selectIsLeaveContactsModalOpened);

  const handleCloseModal = () => dispatch(closeLeaveContactsModal());
  const handleFormSubmit = async (params: TLeaveContactsModalOnSubmitParams) => {
    const result = await dispatch(sendConsultationRequest(params));
    const isError = 'error' in result;

    if (!isError) {
      trackConsultationRequestFormSubmit();
    }

    return {
      status: /* istanbul ignore next */ isError ? 'error' : 'success',
      errorMessage: attemptToGetMessageFromUnknownError(result.error),
    } as const;
  };

  return (
    <LeaveContactsModal isOpen={isOpened} onClose={handleCloseModal} onSubmit={handleFormSubmit} texts={MODAL_TEXTS} />
  );
};
